var styleDataHash = '1245f094';  
export const injectCss = (() => {
  var css = `@charset "UTF-8";.QgfG9,.glob_fontElementMap{font-family:var(--ricos-font-family,unset)}.MhYv1{color:var(--ricos-settings-text-color,#000);font-family:var(--ricos-settings-text-font-family,Madefor,"Helvetica Neue",Helvetica,Arial,メイリオ,meiryo,"ヒラギノ角ゴ pro w3","hiragino kaku gothic pro",sans-serif);font-size:14px}[dir] .MhYv1{background:transparent;cursor:pointer;padding:4px}[dir] .MhYv1:hover{background-color:rgba(var(--ricos-settings-action-color-tuple,var(--ricos-fallback-color-tuple,0,0,0)),.06)}[dir] .MhYv1.JsLES{border:1px solid rgba(var(--ricos-fallback-color-tuple,0,0,0),1);padding:3px}.MhYv1._72t7B{opacity:.4;pointer-events:none}[dir] .MhYv1._72t7B{cursor:default}.K0xue{align-items:center;display:flex;gap:8px;height:20px;justify-content:center;min-width:20px}.K0xue .t51OS{box-sizing:border-box;font-family:inherit;font-size:14px;width:22px}[dir] .K0xue .t51OS{background-color:transparent;border:none}`;
  var isTest = typeof process !== 'undefined' && process.env && process.env['NODE_ENV'] === 'test';

  if (isTest || !css || typeof document === 'undefined') { return; }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.setAttribute('data-ricos-style-hash', styleDataHash);
  style.type = 'text/css';

  head.appendChild(style);

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
});

injectCss();



export default {
  "fontElementMap": "QgfG9",
  "fontSizeModalButtonWrapper": "MhYv1",
  "active": "JsLES",
  "disabled": "_72t7B",
  "fontSizeModalButton": "K0xue",
  "fontSizeModalInputButton": "t51OS"
};